import { Controller } from '@hotwired/stimulus'
import flatpickr from 'flatpickr'
import { German } from 'flatpickr/dist/l10n/de'

// Single flatpickr range field for the bookings list date filter.
// Selecting a range writes both bounds into the hidden filterrific fields and
// submits the shared filter form (same Turbo submit the other filters use).
export default class extends Controller {
  static targets = ['input', 'from', 'to', 'clear']

  connect() {
    const from = this.fromTarget.value
    const to = this.toTarget.value

    this.picker = flatpickr(this.inputTarget, {
      locale: German,
      mode: 'range',
      altInput: true,
      altFormat: 'j. M Y',
      dateFormat: 'Y-m-d',
      disableMobile: true,
      defaultDate: from && to ? [from, to] : undefined,
      onChange: (dates) => this.onChange(dates),
    })

    // Ignore the onChange that flatpickr may emit while applying defaultDate.
    this.ready = true
    this.toggleClear()
  }

  disconnect() {
    if (this.picker) this.picker.destroy()
  }

  onChange(dates) {
    if (!this.ready) return
    if (dates.length === 1) return // wait for a complete range

    this.fromTarget.value = dates[0] ? this.format(dates[0]) : ''
    this.toTarget.value = dates[1] ? this.format(dates[1]) : ''
    this.toggleClear()
    this.submit()
  }

  clear() {
    this.picker.clear()
    this.fromTarget.value = ''
    this.toTarget.value = ''
    this.toggleClear()
    this.submit()
  }

  // Show the in-field clear button only when a range is set.
  toggleClear() {
    if (!this.hasClearTarget) return
    const hasValue = Boolean(this.fromTarget.value || this.toTarget.value)
    this.clearTarget.classList.toggle('d-none', !hasValue)
  }

  // flatpickr Date -> 'YYYY-MM-DD' using local parts (toISOString would shift TZ).
  format(date) {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  submit() {
    this.element.closest('form').requestSubmit()
  }
}
